import Vue from "vue";

import CatalogList from "./CatalogList.vue";

export function load() {
    const selector = "catalog-list";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(CatalogList, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}